module.exports = __webpack_public_path__ + "static/home-c823086a50f001e0695c24c359a4bcfd.mp4";